import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: max-content;
  margin-top: 25px;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
  align-items: flex-start;

  @media screen and (min-width: 300px) {
      width: 100%;
      display: flex
      flex-flow: column wrap;
  }
  `;

export const Products = styled.section`
  width: 50%;
  min-width: 300px;
  height: max-content;
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;

  @media screen and (min-width: 300px) {
    align-content: center;
  }

  div {
    margin: 10px 0;
    display: flex;
    flex-flow: column wrap;
    justify-content: center;
    align-items: center;

    div {
      width: 98%;
      height: 40px;
      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;

      p {
      span {
        font-weight: 700;
        color: var(--red);
      }
    }
    }

    img {
      width: 30vw;
      min-width: 260px;
      max-width: 320px;
      height: 30vh;
      min-height: 220px;
      border-radius: 6px;
    }
  }
`;

export const OrderSummary = styled.aside`
  width: 300px;
  max-width: 300px;
  height: 40vh;
  border-radius: 8px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-evenly;
  align-items: center;
  background-color: var(--mint-cream);
  color: var(--black-russian);
  box-shadow: 3px 6px 13px 5px var(--light-vellow);

  div {
    width: 100%;
    display: flex;
    justify-content: space-around;

    span {
      font-weight: 700;
      color: var(--red);
    }
  }

  .buttons {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  @media screen and (min-width: 300px) {
    width: 96%;
    margin: 30px 0;
  }
`;
